function ReportViewer() {
    return (
        <div>
            <h2>Report Viewer</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default ReportViewer;